import { useGetSingleCvProject } from 'hooks/api/cv-projects';
import { FC } from 'react';

interface CvProjectBreadcrumbsProps {
  match?: any;
}

const CvProjectBreadCrumbs: FC<CvProjectBreadcrumbsProps> = ({ match }) => {
  const { projectId } = match?.params ?? '';

  const { data: cvProject } = useGetSingleCvProject(projectId);
  return <>{cvProject?.data.project.name}</>;
};

export default CvProjectBreadCrumbs;
